import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    textAssinatura: {
        display: 'flex',
        justifyContent: 'flex-start',
        textAlign: 'center',
        marginLeft: '8px',
        [theme.breakpoints.down("md")]: {
            marginLeft: '0px',
            justifyContent: 'center'
        },
    },
    contentAssinatura: {
        height: '75%',
        [theme.breakpoints.down('md')]: {
            height: '78%'
        }
    },
    gridBtn: {
        height: '10%',
        display: 'flex',
        justifyContent: 'center'
    }
}))